import React from 'react';
import styled from 'styled-components';

const DirectionsContainer = styled.div`
  padding: 40px 20px;
  max-width: 800px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #2c5aa0;
  margin-bottom: 20px;
  text-align: center;
`;

const Section = styled.section`
  margin-bottom: 40px;
`;

const SectionTitle = styled.h2`
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 15px;
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
`;

const Address = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
  color: #555;
  text-align: center;
  margin-bottom: 30px;
`;

const MapContainer = styled.div`
  position: relative;
  overflow: hidden;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
`;

const MapEmbed = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
`;

const InfoText = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  color: #333;
`;

const Directions: React.FC = () => {
  return (
    <DirectionsContainer>
      <Title>오시는 길</Title>
      
      <Section>
        <Address>
          240 Goddard, Irvine, CA 92618 U.S.A
        </Address>
        <MapContainer>
          <MapEmbed
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3317.0000000000005!2d-117.79999999999999!3d33.6845678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dcc5c7f9b2c2c1%3A0x4a5b8b7c8b7c8b7c!2s240%20Goddard%2C%20Irvine%2C%20CA%2092618%2C%20USA!5e0!3m2!1sen!2sus!4v1678886400000!5m2!1sen!2sus"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </MapContainer>
      </Section>

      <Section>
        <SectionTitle>주차 안내</SectionTitle>
        <InfoText>
          교회 앞에 있는 주차장에 주차 하실 수 있습니다.
        </InfoText>
      </Section>

      <Section>
        <SectionTitle>연락처</SectionTitle>
        <InfoText>
          Email: ijbcorg@gmail.com
          <br />
          Tel: 949-800-9647
        </InfoText>
      </Section>

    </DirectionsContainer>
  );
};

export default Directions;